import { get, post, put, del } from './requests'

const resourcePath = 'signing_elements'

export function showSigningElement (id) {
  return get(`${resourcePath}/${id}`).then(response => response.data)
}

export function createSigningElement (data) {
  return post(`${resourcePath}`, { signingElement: data })
}

export function updateSigningElement (data) {
  return put(`${resourcePath}/${data.id}`, { signingElement: data })
    .then(response => response)
}

export function ratifyAllSigningElementOccurrences (data) {
  return put(`${resourcePath}/${data.id}/ratify_all_occurrences`, { signingElement: data })
}

export function deleteSigningElement (id) {
  return del(`${resourcePath}/${id}`)
}
